import type { Components } from '@mui/material/styles';

export default function MuiInput(): Components['MuiInput'] {
  return {};
}
